module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt1"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THOMAS DUNNE BOOKS.")]), _c('br'), _vm._v("An imprint of St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GODCHILDREN.")]), _vm._v(" Copyright © 2002 by Nicholas Coleridge. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")]), _c('br'), _c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LIBRARY OF CONGRESS C AT ALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Coleridge, Nicholas, 1957—")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("    Godchildren / Nicholas Coleridge.—1st U.S. ed."), _c('br'), _vm._v("         p. cm."), _c('br'), _vm._v("    ISBN-13: 978-0-312-38258-2"), _c('br'), _vm._v("    ISBN-10: 0-312-38258-8"), _c('br'), _vm._v("    1. Family secrets—Fiction. 2. Domestic fiction. I. Title."), _c('br'), _vm._v("    PR6053.O4218G63 2008"), _c('br'), _vm._v("    823′.914—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2008019639")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First published in Great Britain by Orion Books Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First U.S. Edition: September 2008")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93e54080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312382582_epub_cop_r1.vue
// module id = 63
// module chunks = 0